import React from 'react'
import Address from '../components/core/profile/Address'

const MobileAddress = () => {
  return (
    <div className='w-[90%] mx-auto h-full py-3'>
            <div className='w-full h-full'>
                <Address/>
            </div>
    </div>
  )
}

export default MobileAddress
